angular
  .module 'bookAndPay'
  .directive 'expireWarningMessage', ->
    restrict: 'EA'
    scope:
      cart: '='
    template: require('templates/book_and_pay/expire_warning_message.html.slim')
    controller: ($scope, $interval, BookAndPayService) ->

      calculateMinutesLeft = ->
        now = moment()
        expiry = moment($scope.cart.expires_at)
        minutes = expiry.diff(now, 'minutes')

        $scope.visible = minutes < 6

        if minutes < 1 then 1 else minutes

      $scope.minutesLeft = calculateMinutesLeft()

      intervalId = $interval ->
        BookAndPayService.isExpired($scope.cart, true)
        $scope.minutesLeft = calculateMinutesLeft()
      , 1000

      $scope.$on '$destroy', ->
        $interval.cancel intervalId
